module.exports = __webpack_public_path__ + "static/media/7.1e805fb3.jpg";